var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('splide',{attrs:{"options":_vm.options},on:{"splide:move":_vm.onMove}},_vm._l(((_vm.items.length / 2)),function(i){return _c('splide-slide',{key:i},[_c('div',{staticClass:"item"},[_vm._t((i-1)*2),_vm._t((i-1)*2+1)],2)])}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }